import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { RouterProvider } from "@tanstack/react-router";
import { installPwaAssetRecovery, initSentry, SaveFailedNotice } from "@cliqsuite/ui";
import { SAVE_REFUSED_EVENT } from "@cliqsuite/db/powersync";
import { router } from "./router";
import "./styles.css";

installPwaAssetRecovery();
initSentry("pos", import.meta.env.VITE_SENTRY_DSN, import.meta.env.MODE);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please reload the page.</p>}>
      <RouterProvider router={router} />
      <SaveFailedNotice event={SAVE_REFUSED_EVENT} />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
